import { render } from "./RecordsList.vue?vue&type=template&id=b376e048&scoped=true"
import script from "./RecordsList.vue?vue&type=script&lang=js"
export * from "./RecordsList.vue?vue&type=script&lang=js"

import "./RecordsList.vue?vue&type=style&index=0&id=b376e048&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b376e048"]])

export default __exports__